import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import util from "../util/util";

export default function ScheduleByTimeslotButtons(props) {
  return (
    <div className="row">
      <div className="col-xs-4 col-xs-push-4 text-center">
        {props.loaded === false ? (
          <LoadingIndicatorHeader />
        ) : (
          <div className="schedule-by-timeslot__timeslots">
            <div className="dropdown">
              <h4
                className="page__title dropdown-toggle"
                type="button"
                id="timeslot__dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {props.timeslot}
                <span className="caret"></span>
              </h4>
              <ul
                className="dropdown-menu"
                aria-labelledby="timeslot__dropdown"
              >
                {util.timeSlots.map((timeslot, index) => (
                  <li
                    className={props.timeslot === timeslot ? `active` : null}
                    key={index}
                  >
                    <Link
                      to={util.returnScheduleTimeSlotUrl(timeslot, props.day)}
                    >
                      {timeslot}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>

      <div className="col-xs-4 col-xs-pull-4">
        <p className="page__actions page__actions--prev">
          <Link
            className="btn btn-default"
            to={util.returnScheduleTimeSlotUrl(
              returnTimeslot(props.timeslot, -1),
              props.day
            )}
          >
            <i className="fa fa-arrow-left" aria-hidden="true"></i>
            {returnTimeslot(props.timeslot, -1)}
          </Link>
        </p>
      </div>

      <div className="col-xs-4">
        <p className="page__actions page__actions--next">
          <Link
            className="btn btn-default"
            to={util.returnScheduleTimeSlotUrl(
              returnTimeslot(props.timeslot, 1),
              props.day
            )}
          >
            {returnTimeslot(props.timeslot, 1)}
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </Link>
        </p>
      </div>
    </div>
  );

  // get the prev/next timeslot based on the one passed in;
  function returnTimeslot(timeslot, change) {
    const lastIndex = util.timeSlots.length - 1;
    const currentIndex = util.timeSlots.indexOf(props.timeslot);
    let newIndex = currentIndex + change;

    if (newIndex < 0) {
      newIndex = lastIndex;
    }

    if (newIndex > lastIndex) {
      newIndex = 0;
    }

    return util.timeSlots[newIndex];
  }
}

ScheduleByTimeslotButtons.propTypes = {
  day: PropTypes.string, // used to generate prev/next timeslot links;
  loaded: PropTypes.bool, // has the schedule data been loaded;
  timeslot: PropTypes.string // used in title and link generation;
};
